import React from "react";
import { Container, Grid, Box, Typography, Link, IconButton } from "@mui/material";
import { Facebook, Instagram, Twitter, WhatsApp } from "@mui/icons-material";
import FadeSection from "../components/fadeSection";
import {useFadeInOnScroll, iconStandard} from "../theme/global";
import { useTheme } from "@mui/material/styles";
import "../css/global.css";


const Footer = () => {
  const footerRef = useFadeInOnScroll();
  const mapRef = useFadeInOnScroll();
  const container1Ref = useFadeInOnScroll();
  const container2Ref = useFadeInOnScroll();
  const theme = useTheme();

    const link = {
        textDecoration: "none",
        color: "white",
        fontFamily: "Nunito, sans-serif",
        fontWeight: 400,
        fontSize: "1em",
        "&:hover": {
            color: "#C0DCBD", // Cambia el color al hacer hover
            cursor: "pointer",
          }, 
      };
      

  return (
    <Box
      component="footer"
      id="contacto"
      ref={footerRef} className="footer-fade"
      sx={{
        backgroundColor: "rgb(22, 24, 26)",
        color: "white",
        padding: "2em 4em",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", md: "center" },
        fontFamily: "Nunito, sans-serif",
        fontWeight: 400,
        gap: "2em",
      }}
    >
      
         {/* Mapa con Google Maps Embed */}

         <Box
         ref={mapRef} className="footer-fade"
          sx={{
            ml: 2,
            mt: 2,
            width:{ xs: '100%', md: '550px' },
            height:{ xs: '250px', md: '350px' },
            borderRadius: "10px",
            overflow: "hidden",
          }}
        >
          <iframe
            title="Google Maps"
            width="550"
            height="350"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3168.9980183879944!2d-1.1324226846915972!3d37.97226307972398!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd6381f4ecab5401%3A0x63b0dd8c0f1e1b0b!2sPlaza%20Federico%20Garcia%20Lorca%2C%2014%2C%2030150%20La%20Alberca%2C%20Murcia%2C%20España!5e0!3m2!1ses!2ses!4v1645180902839!5m2!1ses!2ses"
          />
        </Box>
 
      
      <Container ref={container1Ref} className="footer-fade" sx={{display: 'flex', flexDirection: { xs: 'column', md: 'row' }, paddingTop: 4, paddingBottom: 4, alignItems: { xs: 'flex-start', md: 'flex-start' }, gap: '3em'}}>
      
        {/* Contendor 1 */}    
        <Grid container justifyContent="center" sx={{display: 'flex', flexDirection: 'row', alignSelf: 'flex-start', alignItems: 'flex-start', gap: '1em'}}>
          {/* Dirección */}
          <Grid item xs={12} sm={4} lg={12} textAlign={{ xs: "left", sm: "left", lg: 'left' }} sx={{display: 'flex', flexDirection: 'column',}}>
            <Typography variant="h6" gutterBottom sx={{fontFamily: "Nunito, sans-serif",
                fontWeight: 700,}}>
              Dirección
            </Typography>
            <Link variant="body2" gutterBottom sx={link} href="https://maps.app.goo.gl/fUv1p1p5us82jySF9" target="_blank">
              Plaza Federico García Lorca, Nº 14, Bajo
              Alberca de las torres, 30150 (Murcia)
            </Link>
          </Grid>

            {/* Contacto */}
          <Grid  item xs={12} sm={4} lg={12} textAlign={{ xs: "left", sm: "left", lg: 'left' }} sx={{display: 'flex', flexDirection: 'column',}}>
          <Typography variant="h6" gutterBottom sx={{fontFamily: "Nunito, sans-serif",
                fontWeight: 700,}}>
              Contacto
            </Typography>
            <Link
              variant="body2"
              gutterBottom
              sx={{ ...link, display: "flex", alignItems: "center" }}
              href="https://wa.me/34614224342"
              target="_blank"
              rel="noopener noreferrer"
            >
              <WhatsApp sx={{ mr: 0.5 }} />
              +34 614 22 43 42
            </Link>
            <Link
              variant="body2"
              gutterBottom
              sx={{ ...link, display: "flex", alignItems: "center" }}
              href="https://wa.me/34614253842"
              target="_blank"
              rel="noopener noreferrer"
            >
                <WhatsApp sx={{ mr: 0.5 }} />
                +34 614 25 38 42
            </Link>
            <Link variant="body2" gutterBottom sx={link} href="mailto: info@cespsicologiaybienestar.com">
                info@cespsicologiaybienestar.com
            </Link>
           </Grid>             
           </Grid>

          {/* Contendor 2 */}
        <Grid ref={container2Ref} className="footer-fade"  container   justifyContent="center" sx={{display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: {xs: 'flex-start', sm: 'flex-start', md: 'center'}, gap: '1em',}}>
        
        {/* Redes Sociales */}
        <Grid item xs={12} sm={4} lg={12} textAlign={{ xs: "left", sm: "left", lg: 'left' }} sx={{display: 'flex', flexDirection: 'column', 
            alignItems: { xs: 'flex-start', sm: 'flex-start', lg: 'flex-start'},
        }}>
            <Typography variant="h6" gutterBottom 
            sx={{fontFamily: "Nunito, sans-serif",
                fontWeight: 700,}}>
              Síguenos
            </Typography>            
            <IconButton sx={{alignSelf: 'flex-start',
             transition: "all 0.3s ease-in-out",
             color: '#ffffff',
             "&:hover": {
                //color: "linear-gradient(45deg, #F58529, #DD2A7B, #8134AF, #515BD4)",
               color: " #8134AF",
                cursor: "pointer",
              },
            }} href="https://www.instagram.com/cespsicologiaybienestar?utm_source=qr&amp;igsh=MWJieGIxaDBmdDVhdQ==">
              <Instagram sx={{    color: '#fffff',
                 "&:hover": {
                  // color: " #8134AF",
                 }
                }} />
            </IconButton>
          </Grid>

           {/* Legal */}
           <Grid item xs={12} sm={4} lg={12} textAlign={{ xs: "left", sm: "left", lg: 'left' }} sx={{display: 'flex', flexDirection: 'column', width: '100%'}}>
            <Typography variant="h6" gutterBottom 
            sx={{fontFamily: "Nunito, sans-serif",
                fontWeight: 700,}}>
              Legal
            </Typography>            
            <Link href="/avisoLegal" variant="body2" gutterBottom sx={link}>
              Aviso Legal
            </Link>
            <Link href="/politicaPrivacidad" variant="body2" gutterBottom sx={link}>
              Política de privacidad
            </Link>
            <Link href="/politicaCookies" variant="body2" gutterBottom sx={link}>
             Política de cookies
            </Link>
            <Typography variant="body2" gutterBottom sx={{fontFamily: "Nunito, sans-serif",
                fontWeight: 400, pt: 2,}}>
              © {new Date().getFullYear()} Todos los derechos reservados.
            </Typography>
          </Grid>
          </Grid>

          
        
      </Container>
    </Box>
  );
};

export default Footer;
